module.exports = __webpack_public_path__ + "img/main-features.f9ac7de4.png";